export const ORIENTATION_VERTICAL = "vertical";
export const PLACEMENT_TOP = "top";
export const PLACEMENT_BOTTOM = "bottom";
export const PROP_PANEL_GUTTER_SIZE = ".75rem";
export const FLYOUT_SHIFT_LEFT = "left";
export const FLYOUT_SHIFT_RIGHT = "right";

export const STAGE_OVERLAY_MOBILE = "mobile";
export const STAGE_OVERLAY_GUIDES = "guides";
export const STAGE_OVERLAY_COLUMN = "columnGuides";
export const STAGE_OVERLAY_CENTER = "centerGuides";
export const STAGE_OVERLAY_SNAP = "enableSnapping";

export const STAGE_VIEW_MIN_WIDTH = 200;
export const MOBILE_STAGE_VIEW_RATIO = 0.25;
export const MOBILE_OVERLAY_OFFSET = 20;
export const ZOOM_TO_FIT_SCALE = 95;
export const STAGE_SCALE_BREAKPOINT = 1680;

export const MAX_ZOOM = 5;
export const MIN_ZOOM = 0.3;
export const ZOOM_INCREMENT = 0.1;
export const SCROLL_ZOOM_AMOUNT_TRACKPAD = 0.05;

export const STAGE_TOP_PADDING = 64;
// screen px a finger must travel before a press becomes a drag
export const TOUCH_DRAG_THRESHOLD_PX = 6;
export const VERTICAL_RULER_WIDTH = 16;
export const LAYOUT_MOBILE_WIDTH = 320;
export const LAYOUT_DESKTOP_WIDTH = 1200;

export const COLOR_MODE_LIGHT = "light";
export const COLOR_MODE_DARK = "dark";
export const COLOR_MODE_AUTO = "auto";
export const COLOR_MODE_CHAOS = "chaos";
export const COLOR_MODES = [COLOR_MODE_LIGHT, COLOR_MODE_DARK, COLOR_MODE_AUTO];

export const UI_SCALE_SMALL = "12px";
export const UI_SCALE_REGULAR = "16px";
export const UI_SCALE_LARGE = "22px";

export const CROP_MODE = "cropMode";
export const DEFAULT_MODE = "defaultMode"
export const GROUP_FOCUS_MODE = "groupFocusMode";